module.exports = require('./helpers/bundle-url').getBundleURL('kmWVw') + "logo.c51670a8.svg";